export class Coupon {
    constructor({
                    id = null,
                    cod = '',
                    model:{
                        type=1,
                        value=0.0
                    } = {},
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                } = {}) {

        this.id = id;
        this.cod = cod;
        this.type=type===1?'percent':'value'
        this.value=value
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;
        this.model = {
            type:type,
            value:value
        }
    }

    applyToValue(value){
        if(this.type==='percent')
            return value-value*this.value/100;
        else
            return value-this.value
    }
}

export function createCoupon(data={}) {
    return Object.freeze(new Coupon(data));
}